import React, { useState } from 'react';
import { Trash2, ArrowUp, ArrowDown, Plus, Image as ImageIcon, Upload, Loader2 } from 'lucide-react';
import { Button } from '../ui/Button';
import { useHeroImages } from '../../hooks/useHeroImages';
import { compressImage } from '../../utils/imageUtils';
export function HeroImagesSection() {
  const {
    images,
    addImage,
    deleteImage,
    moveImage,
    canAdd
  } = useHeroImages();
  const [isProcessing, setIsProcessing] = useState(false);
  const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setIsProcessing(true);
      try {
        const file = e.target.files[0];
        const compressed = await compressImage(file);
        addImage(compressed);
      } catch (error) {
        console.error('Error processing image:', error);
        alert('Error al procesar la imagen.');
      } finally {
        setIsProcessing(false);
        e.target.value = '';
      }
    }
  };
  const handleDelete = (id: number) => {
    if (window.confirm('¿Estás seguro de eliminar esta imagen del carrusel?')) {
      deleteImage(id);
    }
  };
  return <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6 mb-8" data-id="element-219">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4" data-id="element-220">
        <div data-id="element-221">
          <h2 className="text-xl font-bold text-gray-900 flex items-center gap-2" data-id="element-222">
            <ImageIcon className="h-5 w-5 text-blue-600" data-id="element-223" />
            Imágenes del Hero
          </h2>
          <p className="text-sm text-gray-500 mt-1" data-id="element-224">
            Gestiona las imágenes de fondo del inicio (máximo 4). Se rotarán
            automáticamente cada 6 segundos.
          </p>
        </div>
        <div className="text-sm font-medium bg-blue-50 text-blue-700 px-3 py-1 rounded-full border border-blue-100" data-id="element-225">
          {images.length} / 4 imágenes
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6" data-id="element-226">
        {images.map((image, index) => <div key={image.id} className="group relative bg-gray-50 rounded-lg border border-gray-200 overflow-hidden hover:shadow-md transition-all" data-id="element-227">
            <div className="aspect-video w-full relative overflow-hidden bg-gray-100" data-id="element-228">
              <img src={image.url} alt={`Hero background ${index + 1}`} className="w-full h-full object-cover" data-id="element-229" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors" data-id="element-230" />

              {/* Overlay controls */}
              <div className="absolute inset-0 flex items-center justify-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity bg-black/20 backdrop-blur-[1px]" data-id="element-231">
                <button onClick={() => moveImage(image.id, 'up')} disabled={index === 0} className="p-1.5 bg-white text-gray-700 hover:text-blue-600 rounded shadow-sm disabled:opacity-50 disabled:cursor-not-allowed" title="Mover al inicio" data-id="element-232">
                  <ArrowUp className="h-3 w-3" data-id="element-233" />
                </button>
                <button onClick={() => moveImage(image.id, 'down')} disabled={index === images.length - 1} className="p-1.5 bg-white text-gray-700 hover:text-blue-600 rounded shadow-sm disabled:opacity-50 disabled:cursor-not-allowed" title="Mover al final" data-id="element-234">
                  <ArrowDown className="h-3 w-3" data-id="element-235" />
                </button>
                <button onClick={() => handleDelete(image.id)} className="p-1.5 bg-white text-red-500 hover:text-red-700 rounded shadow-sm" title="Eliminar" data-id="element-236">
                  <Trash2 className="h-3 w-3" data-id="element-237" />
                </button>
              </div>
            </div>

            <div className="p-2 bg-white border-t border-gray-100" data-id="element-238">
              <p className="text-[10px] font-medium text-gray-500 uppercase tracking-wider mb-0.5" data-id="element-239">
                Imagen {index + 1}
              </p>
            </div>
          </div>)}
      </div>

      {canAdd ? <label className={`
          inline-flex items-center justify-center gap-2 px-4 py-2 rounded-lg border-2 border-dashed border-gray-300 
          cursor-pointer hover:border-blue-500 hover:bg-blue-50 transition-colors w-full sm:w-auto
          ${isProcessing ? 'opacity-50 cursor-not-allowed' : ''}
        `} data-id="element-240">
          {isProcessing ? <Loader2 className="h-4 w-4 text-blue-500 animate-spin" data-id="element-241" /> : <Upload className="h-4 w-4 text-gray-500" data-id="element-242" />}
          <span className="text-sm font-medium text-gray-700" data-id="element-243">
            {isProcessing ? 'Procesando...' : 'Subir nueva imagen'}
          </span>
          <input type="file" accept="image/*" className="hidden" onChange={handleImageUpload} disabled={isProcessing} data-id="element-244" />
        </label> : <div className="text-center p-4 bg-gray-50 rounded-lg border border-gray-200 text-sm text-gray-500" data-id="element-245">
          Has alcanzado el límite máximo de 4 imágenes. Elimina una para agregar
          otra.
        </div>}
    </div>;
}